"use strict";
/* eslint-disable no-param-reassign */
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const makeGroupBySingleFieldPointerMethod_1 = require("../makeGroupBySingleFieldPointerMethod");
exports.concentrationLimitPointerMethods = [
    (0, makeGroupBySingleFieldPointerMethod_1.makeGroupBySingleFieldPointerMethod)({
        field: 'industry',
        method: 'clearcoPollenStreetCapital1.singleIndustry',
        type: 'string',
    }),
    (0, makeGroupBySingleFieldPointerMethod_1.makeGroupBySingleFieldPointerMethod)({
        field: 'business_name',
        method: 'clearcoPollenStreetCapital1.singleMerchant',
        type: 'string',
    }),
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map